import "./InfoSection.css";
import openFileImg from './img/OpenFile.png';
import submitImage from './img/Submit.png';
import outputImage from './img/Output.png';

function InfoSection(){
    return (
        <div id="info-section">
            <h3>Instructions:</h3>
            <div id="inst-container">
                <div className="inst-card">
                    <img src={openFileImg} />
                    <br/>
                    <strong>1. Select a SOAR file</strong>
                    <br/>
                    <strong>2. Submit the file</strong>
                </div>
                <div className="inst-card">
                    <img src={outputImage} />
                    <strong>3. Download the Output</strong>
                </div>

            </div>
        </div>
    );
}

export default InfoSection;